/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 06/12/2021.
 */
import { Suspense, useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { Header } from './components/header/Header'
import AutoLogOutModal from './components/modals/AutoLogOutModal'
import { SpinnerFullHeight } from './components/spinner/SpinnerFullHeight'
import {
  LAST_AUTOLOGOUT_PAGE_EXPIRERY,
  LAST_AUTOLOGOUT_PAGE_KEY,
  LAST_AUTOLOGOUT_TIME_KEY,
  PROJECT_PAGE,
  STATS_PAGE,
  STATS_PAGE_ALL_PROJECTS,
} from './constants'
import { AssignmentPage } from './pages/assignment/AssignmentPage'
import { FrontPage } from './pages/frontpage/FrontPage'
import { ProjectPage } from './pages/project/ProjectPage'
import { StatsPage } from './pages/stats/StatsPage'
import { StatsPageAllProjects } from './pages/stats/allProjects/StatsPageAllProjects'

export const Main = () => {
  const navigate = useNavigate()

  useEffect(() => {
    try {
      // if we were auto logged out lately, we want to return to the last page.
      const lastAutoLogOutTime: string | null = window.localStorage.getItem(LAST_AUTOLOGOUT_TIME_KEY)
      const lastTabPathName: string | null = window.localStorage.getItem(LAST_AUTOLOGOUT_PAGE_KEY)

      if (!lastAutoLogOutTime || !lastTabPathName) {
        return
      }

      if (Date.now() < Number(lastAutoLogOutTime) + LAST_AUTOLOGOUT_PAGE_EXPIRERY) {
        // auto-logged out lately. Should redirect to last page.
        navigate(lastTabPathName)

        window.localStorage.removeItem(LAST_AUTOLOGOUT_TIME_KEY)
        window.localStorage.removeItem(LAST_AUTOLOGOUT_PAGE_KEY)
      }
    } catch (err) {
      console.log('Wrapper >> maybe redirect to last active page on signin error:', err)
    }
  }, [navigate])

  return (
    <>
      <Header></Header>
      <AutoLogOutModal />
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<SpinnerFullHeight />}>
              <FrontPage></FrontPage>
            </Suspense>
          }
        />

        <Route
          path={PROJECT_PAGE.to}
          element={
            <Suspense fallback={<SpinnerFullHeight />}>
              <ProjectPage></ProjectPage>
            </Suspense>
          }
        />

        <Route
          path={STATS_PAGE.to}
          element={
            <Suspense fallback={<SpinnerFullHeight />}>
              <StatsPage />
            </Suspense>
          }
        />
        <Route
          path={STATS_PAGE_ALL_PROJECTS.to}
          element={
            <Suspense fallback={<SpinnerFullHeight />}>
              <StatsPageAllProjects />
            </Suspense>
          }
        />

        <Route
          path={`/assignment/:projectId/*`}
          element={
            <Suspense fallback={<SpinnerFullHeight />}>
              <AssignmentPage></AssignmentPage>
            </Suspense>
          }
        />
      </Routes>
    </>
  )
}
